import React, { FunctionComponent, useContext } from 'react';
import styles from './quote-with-image.module.scss';
import { AppDeviceSize } from '../../enums/app-device-size';
import { AppStore } from '../../store/app.context';
import { Fade } from 'react-awesome-reveal';
import classNames from 'classnames/bind';
import { IEmployeeBoxProps } from '../employee-box/employee-box';

export interface IQuoteWithImageProps {
  sectionTitle?: string;
  quoteTitle?: string;
  quote: string;
  additionamMarginInColumn?: string;
  additionamMarginInRow?: string;
  id?: string;
  author: IEmployeeBoxProps;
  type?: string;
}

const cx = classNames.bind(styles);

export const QuoteWithImage: FunctionComponent<IQuoteWithImageProps> = ({
  sectionTitle,
  quoteTitle,
  quote,
  author,
  id,
  additionamMarginInColumn,
  additionamMarginInRow,
  type
}) => {
  const { state } = useContext(AppStore);
  const { showActiveDevice } = state;

  const wrapperClass = cx({
    marginSmallColumn: additionamMarginInColumn === 'small',
    marginMediumColumn: additionamMarginInColumn === 'medium',
    marginLargeColumn: additionamMarginInColumn === 'large',
    marginExtraLargeColumn: additionamMarginInColumn === 'extra_large',
    marginSmallRow: additionamMarginInRow === 'small',
    marginMediumRow: additionamMarginInRow === 'medium',
    marginLargeRow: additionamMarginInRow === 'large',
    marginExtraLargeRow: additionamMarginInRow === 'extra_large'
  });

  const authorImageElement = author.photoUrl && (
    <img className={styles.authorImage} src={author.photoUrl} alt="author" />
  );

  // Display content without animation
  const rightSide = (
    <div className={styles.rightSideBackground}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.sectionTitle}>{sectionTitle}</h2>
        <div className={styles.quoteWrapper}>
          <div className={styles.quoteTitleWrapper}>
            {showActiveDevice <= AppDeviceSize.SMALLDESKTOP &&
              authorImageElement}
            <div>
              <i className={`material-icons md-40 md-primary`}>format_quote</i>
              <i className={`material-icons md-40 md-primary`}>format_quote</i>
              <h3 className={styles.quoteTitle}>{quoteTitle}</h3>
            </div>
          </div>
          <p className={styles.quote}>{quote}</p>
          <div className={styles.quoteAuthorInfo}>
            <div>
              {author.firstName} {author.lastName}
            </div>
            <div>{author.position}</div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      {type === 'animated_section' ? (
        <section id={id} className={`${styles.wrapper} ${wrapperClass}`}>
          {showActiveDevice > AppDeviceSize.SMALLDESKTOP ? (
            <React.Fragment>
              <Fade direction="left" triggerOnce>
                <div className={styles.leftSideBackground}></div>
              </Fade>
              <div className={styles.rightSide}>
                <Fade delay={800} triggerOnce>
                  {authorImageElement}
                </Fade>
                <Fade direction="right" triggerOnce>
                  {rightSide}
                </Fade>
              </div>
            </React.Fragment>
          ) : (
            rightSide
          )}
        </section>
      ) : (
        <div className={styles.roundedImage}>
          <div className={styles.authorBox}>
            {author.photoUrl && (
              <div className={styles.authorPhoto}>
                <img src={author.photoUrl} alt="author" />
              </div>
            )}
            <div className={styles.authorInfo}>
              <div className={styles.authorName}>
                {author.firstName} {author.lastName}
              </div>
              <div className={styles.authorPosition}>
                {author.position} <br />
                SoftwareHut
              </div>
            </div>
          </div>
          <div className={styles.quotes}>
            <i className={`material-icons md-40 md-primary`}>format_quote</i>
            <i className={`material-icons md-40 md-primary`}>format_quote</i>
          </div>
          <p className={styles.quote}>{quote}</p>
        </div>
      )}
    </React.Fragment>
  );
};
